import classNames from 'classnames'
import React from 'react'
import { ScrollMenu, VisibilityContext } from 'react-horizontal-scrolling-menu'

const ArrowLeft = () => {
  const { scrollPrev } = React.useContext(VisibilityContext) as any

  return (
    <div className="flex items-center text-gray-300" onClick={() => scrollPrev()}>
      <i className="fe fe-chevron-left"></i>
    </div>
  )
}
const ArrowRight = () => {
  const { scrollNext } = React.useContext(VisibilityContext) as any

  return (
    <div className="flex items-center text-gray-300" onClick={() => scrollNext()}>
      <i className="fe fe-chevron-right"></i>
    </div>
  )
}

type TabScrollNavsLightPropsType = {
  data: any
  activeId?: any
  setActiveId?: any
  sm?: any
  md?: any
  xl?: any
  arrowIcon?: any
  mobile?: any
  isModal?: any
  lg?: any
  style?: any
}

const TabScrollNavsLight = ({
  data,
  activeId,
  setActiveId,
  sm,
  md,
  xl,
  arrowIcon,
  mobile,
  isModal,
  lg,
  style,
}: TabScrollNavsLightPropsType) => {
  const visibility = React.useContext(VisibilityContext)

  const onWheel = (apiObj, ev: React.WheelEvent): void => {
    ev.stopPropagation()
    // ev.preventDefault()

    if (ev.deltaY < 0) {
      apiObj.scrollNext()
    } else if (ev.deltaY > 0) {
      apiObj.scrollPrev()
    }
  }

  return (
    <div
      style={style}
      className={classNames('mb-16 align-bottom', mobile ? '-ml-20 -mr-20' : '', isModal && 'modal-tab')}
    >
      <ScrollMenu
        wrapperClassName="flex"
        itemClassName={'whitespace-nowrap flex-1'}
        LeftArrow={arrowIcon ? ArrowLeft : <></>}
        RightArrow={arrowIcon ? ArrowRight : <></>}
        onWheel={onWheel}
      >
        {data
          ?.filter((d) => d != false && d.none != true)
          .map((item, i) => {
            return (
              <Tab
                key={i}
                activeId={activeId}
                setActiveId={setActiveId}
                item={item}
                isModal={isModal}
                sm={sm}
                md={md}
                lg={lg}
                xl={xl}
              />
            )
          })}
      </ScrollMenu>
    </div>
  )
}
export default TabScrollNavsLight

const Tab = ({ activeId, setActiveId, item, isModal, sm, md, lg, xl }) => {
  return (
    <div
      onClick={() => setActiveId(item.id)}
      key={item.id}
      style={{ verticalAlign: 'middle', minWidth: '100px' }}
      className={classNames(
        'text-14 inline-block flex h-48 w-full cursor-pointer items-center justify-center  text-center',
        item.id == activeId ? 'border-b-1 border-purple-500 bg-gray-100 text-purple-500' : 'text-gray-300',
        item.id != activeId && !isModal && 'border-b-1',
        sm ? 'mx-1 px-32' : '',
        md ? 'px-40' : 'px-16',
        lg ? 'btn-lg-tab' : '',
        xl ? 'px-64' : ''
      )}
    >
      {item.title}
    </div>
  )
}
